import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROPicklistView = get('reservation.routes.ROPicklist.view');

export const getROPicklistViewData = createSelector(
  getROPicklistView,
  get('data')
);

export const getIsFetching = createSelector(getROPicklistView, get('fetching'));

export const getIsFetched = createSelector(getROPicklistView, get('fetched'));
